export class MeterSpaceRepresentation {
    meterGuid: string;
    numberOfSpaces: number;
    actionsAffected: Array<number> = new Array<number>();
    contractTypeFlag: boolean = false;
}